

































































































































































































































































































































import Vue, { PropType } from "vue";
import FieldDataChart from "@/features/coreWebVitals/components/fieldDataChart.vue";
import { FieldDataContent } from "@/features/coreWebVitals/types";
import {
  getFcpMark,
  getLcpMark,
  getFidMark,
  getClsMark,
  getInpMark,
  getTtfbMark,
} from "@/features/coreWebVitals/utils";

export default Vue.extend({
  components: {
    "field-data-chart": FieldDataChart,
  },
  props: {
    fieldData: { type: Object as PropType<FieldDataContent>, required: true },
    loading: { type: Boolean, required: true },
    isNoSelectDomain: { type: Boolean, required: true },
    fieldDataLastUpdateDate: { type: String, required: true },
    isDisplayAllNoData: { type: Boolean },
  },
  methods: {
    isNoFieldFcpData() {
      return this.fieldData.fcp.fcpScore === null;
    },
    isNoFieldFidData() {
      return this.fieldData.fid.fidScore === null;
    },
    isNoFieldLcpData() {
      return this.fieldData.lcp.lcpScore === null;
    },
    isNoFieldClsData() {
      return this.fieldData.cls.clsScore === null;
    },
    isNoFieldInpData() {
      return this.fieldData.inp.inpScore === null;
    },
    isNoFieldTtfbData() {
      return this.fieldData.ttfb.ttfbScore === null;
    },
    getFcpColor(data: number) {
      const [colorCode, _] = getFcpMark(data);
      return colorCode;
    },
    getFidColor(data: number) {
      const [colorCode, _] = getFidMark(data);
      return colorCode;
    },
    getLcpColor(data: number) {
      const [colorCode, _] = getLcpMark(data);
      return colorCode;
    },
    getClsColor(data: number) {
      const [colorCode, _] = getClsMark(data);
      return colorCode;
    },
    getInpColor(data: number) {
      const [colorCode, _] = getInpMark(data);
      return colorCode;
    },
    getTtfbColor(data: number) {
      const [colorCode, _] = getTtfbMark(data);
      return colorCode;
    },
    getFcpSharp(data: number) {
      const [_, sharp] = getFcpMark(data);
      return sharp;
    },
    getFidSharp(data: number) {
      const [_, sharp] = getFidMark(data);
      return sharp;
    },
    getLcpSharp(data: number) {
      const [_, sharp] = getLcpMark(data);
      return sharp;
    },
    getClsSharp(data: number) {
      const [_, sharp] = getClsMark(data);
      return sharp;
    },
    getInpSharp(data: number) {
      const [_, sharp] = getInpMark(data);
      return sharp;
    },
    getTtfbSharp(data: number) {
      const [_, sharp] = getTtfbMark(data);
      return sharp;
    },
    isDisplaySupplement() {
      return (
        !this.isNoSelectDomain &&
        !this.loading &&
        this.fieldDataLastUpdateDate !== "" &&
        !this.isDisplayAllNoData
      );
    },
  },
});
